import i18n from 'i18next'
import Api from '#services/api'
import {setUser} from '#services/storage'
import {buildPermissions} from '#services/permissions'

export function pending(user) {
  return {
    ...user,
    isLoggingIn: true,
  }
}

export function fulfilled(state, payload, result) {
  return {
    ...state,
    ...result,
    isLoggingIn: false,
    isLoggedIn: true,
    permissions: buildPermissions({role: result.role}),
  }
}

export function rejected(user, payload, error) {
  return {
    ...user,
    isLoggingIn: false,
    isLoggedIn: false,
    loginError: error && error.message ? error.message : i18n.t('misc_unknown_error'),
  }
}

export async function action(payload) {
  try {
    const result = await Api.getUserById(payload.id)
    const {...user} = result
    setUser(user)
    return {
      ...result,
      ausbildungsnachweistyp: result.ausbildungsnachweisTyp,
    }
  } catch (e) {
    throw new Error(i18n.t(e.message))
  }
}
